export const coerceToBool = (
  value: string | boolean | number | undefined | null,
): boolean => {
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  } else if (typeof value === "boolean") {
    return value;
  } else if (typeof value === "number") {
    return value === 1;
  }
  return false;
};
